<template>
  <!-- <el-table :data="$attrs.data"> -->
  <div class="baseTable">
    <el-table
      fit
      v-bind="$attrs"
      :border="$attrs.border || 'border'"
      v-loading="false"
      style="width: 100%;border-left:1px solid #EBEEF5;"
      ref="table"
      class="v2-base-table"
      :stripe="false"
      :row-key="$attrs.rowKey"
      v-on="$listeners"
      :highlight-current-row="false"
    >
      <el-table-column
        v-for="col in tableColumn"
        :align="col.align || 'center'"
        v-bind="col"
      >
        <!--自定义渲染行-->
        <template slot-scope="scope">
          <col-render :scope="scope" :col="col" :render="col.render" />
        </template>

        <!--自定义渲染表头-->
        <template slot="header" slot-scope="scope">
          <render-head
            class="has-gutter"
            v-if="col.renderHead"
            v-bind="{ scope: { ...scope }, col: col }"
          />
          <span v-else class="has-gutter">{{ col.label }}</span>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
// 处理字段值是 null , ''的情况
const resolveEmptyValue = val => {
  switch (val + '') {
    case '':
      return '-';
    default:
      return false;
  }
};
export const colRender = {
  functional: true,
  render: (h, ctx) => {
    const { render, scope, col } = ctx.props;
    const { row } = scope;
    const { formatter } = col;
    // 不需要验证 字段值的情况 ，比如合同详情列 都是 ’详情‘
    if (col.prop === '' || col.prop === undefined) {
      if (!render) {
        console.dir(ctx.props);
        throw new Error(
          `表格props tableColumn 的 数据项 ${col.label} prop 如果为空 ，需要render`
        );
      }
      return render(h, { scope, row, col }, ctx.parent.$parent);
    }

    if (!(col.prop in row)) {
      console.error(`缺失字段：${col.prop}`, `row数据：${row}`);
      return h('span', '-');
    }

    // 行数据存在对应字段
    let val = row[col.prop];

    // 处理 特殊值 处理过是 '-' ，没处理是 false
    let specialV = resolveEmptyValue(val);

    return specialV
      ? h('span', specialV)
      : render
      ? render(h, { scope, row, col, cellValue: val }, ctx.parent.$parent)
      : formatter
      ? h('span', formatter(val, row) || '-')
      : h('span', val || '-');
  }
};
export default {
  name: 'base-table',
  props: {
    tableColumn: {
      type: [Array],
      default: function() {
        return [];
      }
    }
  },
  components: {
    // 自定义渲染组件
    colRender: colRender,
    renderHead: {
      name: 'renderHead',
      functional: true,
      render: (h, ctx) => {
        return ctx.props.renderHead(h, { ...ctx.props }, ctx.parent.$parent);
      }
    }
  },
  data() {
    return {
      selection: []
    };
  },
  methods: {
    clearSelection() {
      this.$refs.table.clearSelection();
    }
  }
};
</script>
<style lang="scss" scoped>
.baseTable {
  ::v-deep {
    .v2-base-table thead {
      border-radius: 5px 5px 0 0;
    }

    .v2-base-table thead > tr th {
      background: transparent !important;
      border: 0.5px solid #a3d0fd;
    }

    .v2-base-table thead > tr {
      background-color: #e6f1fc !important;
    }
  }
}
</style>
